export const DAO_CODE = "STAFFING_DAO"
